import React, { useState, useEffect } from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { YhBox } from "../../../../components2/YhBox";
import { DescriptionColorEnum, IDescription } from "../../../../components2/YhBox/Types";
import { Button, message } from "antd";
import { useDataCatalogModel } from "../dataCatalogModel";
import { DetailType } from "../dataCatalogTypes";
import { useNavModel } from "../../../../model/navModel";
import { globalPrompt } from "../../../../components2/YhMessage"
import DataTable from "./DataTable"
import { useControllableValue } from "ahooks";
const DataBox = () => {
    const { addNav } = useNavModel()
    const { dataSource, selectedRowKeys, cataLogPage, loadData, setSelectedRowKeys } = useDataCatalogModel();
    const CatalogDetail = (type: string) => {
        const id = selectedRowKeys[0] as string //这里做类型转换
        switch (type) {
            case DetailType.add:
                return addNav("1-1-1", { id: "", mode: type });
            case DetailType.edit:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要编辑的数据" })
                return addNav("1-1-2", { id, mode: type });
            case DetailType.look:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要查看的数据" })
                return addNav("1-1-3", { id, mode: type });
            default:
                return false
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => CatalogDetail("add")}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => CatalogDetail("edit")}
        >编辑</Button>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => CatalogDetail("look")}
        >查看</Button> */}
    </>
    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}
export default DataBox